const img = 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/home/3e62889ac8886cf21418aa052d7cad127113bd38c309c595d375879f5db6ae4a.png';
import Image from 'components/image/cdnImage';
import Head from 'next/head';

export default function IndexView() {
  return (
    <>
      <Head>
        <title>下载中心 - 小鱼易连</title>
      </Head>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          background: '#fff',
          overflow: 'hidden',
        }}
      >
        <Image styles={{ width: '100%', height: '160.8vw' }} src={img} alt="download" />
      </div>
    </>
  );
}
